var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7028 2.96448C13.8584 -0.879914 7.6182 -0.879914 3.7738 2.96448C-0.0705881 6.80887 -0.0705874 13.049 3.7738 16.8934C7.6182 20.7378 13.8584 20.7378 17.7028 16.8934C21.5471 13.049 21.5472 6.80887 17.7028 2.96448ZM13.5241 14.1076L10.7383 11.3219L7.95249 14.1076L6.5596 12.7147L9.34539 9.92896L6.55959 7.14316L7.95249 5.75027L10.7383 8.53606L13.5241 5.75027L14.917 7.14316L12.1312 9.92896L14.917 12.7147L13.5241 14.1076Z",
    fill: "#FC3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.60f62c3b5e5c971c4577ef191f06d6ef.svg";
export { ForwardRef as ReactComponent };